<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>内部管理</el-breadcrumb-item>
        <el-breadcrumb-item>广州睿眼进销存</el-breadcrumb-item>
        <el-breadcrumb-item>进货</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <!-- 进货 strat -->
      <el-tab-pane name="first" label="进货">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入产品名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="success" @click="clickexcel()">导出</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Name" label="产品名称" min-width="10%"></el-table-column>
          <el-table-column prop="Innum" label="进货数量" min-width="10%"></el-table-column>
          <el-table-column prop="Inprice" label="进货单价" min-width="10%"></el-table-column>
          <el-table-column prop="Inamount" label="进货总金额" min-width="10%"></el-table-column>
          <el-table-column prop="Beizhu" label="备注" min-width="15%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="15%"></el-table-column>
          <el-table-column prop="Operation" min-width="9%" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.$index,scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>

        <!-- 编辑进货弹出框 start -->
        <el-dialog title="编辑进货" :visible.sync="editdialog" width="40%" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editFormRef" label-width="140px">
          <el-form-item label="">
            <label slot="label">
              <span style="color: #FF0000;">产品名称</span>
            </label>
            <el-select v-model="editForm.Name" placeholder="请选择产品名称" class="select" style="width: 150px;">
              <el-option
                v-for="item in nameList" :key="item.Name" :label="item.Name" :value="item.Name">
              </el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="进货数量" class="addAdminForm">
              <el-input v-model="editForm.Innum" placeholder="请输入进货数量"></el-input>
            </el-form-item>
            <el-form-item label="备注" class="addAdminForm">
              <el-input v-model="editForm.Beizhu" placeholder="请输入备注"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="funsaveedit">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 编辑进货弹出框 end -->
      </el-tab-pane>
      <!-- 进货 end -->

      <!-- 添加进货 start -->
      <el-tab-pane name="second" label="添加进货">
        <el-form :model="addForm" ref="addFormRef" label-width="140px">
          <el-form-item label="">
            <label slot="label">
              <span style="color: #FF0000;">产品名称</span>
            </label>
            <el-select v-model="addForm.Name" placeholder="请选择产品名称" class="select" style="width: 150px;">
              <el-option
                v-for="item in nameList" :key="item.Name" :label="item.Name" :value="item.Name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="进货数量" class="addAdminForm">
            <el-input v-model="addForm.Innum" placeholder="请输入进货数量"></el-input>
          </el-form-item>
          <el-form-item label="备注" class="addAdminForm">
            <el-input v-model="addForm.Beizhu" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="funsaveadd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加进货 end -->

    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyNaoxjStockStock',
  data () {
    return {
      keywords: {
        name: ''
      },
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      nameList: [],
      addForm: {
        Name: '',
        Innum: '0',
        Beizhu: ''
      },
      editForm: {
        Id: 0,
        Name: '',
        Innum: '0',
        Beizhu: ''
      },
      editdialog: false
    }
  },
  mounted () {
    this.apiGetNaoxjStockStocknum()
    this.apiGetNaoxjStockStocklist()
    this.apiGetNaoxjStockCatalogNameList()
  },
  methods: {
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetNaoxjStockStocklist()
    },
    handleClick (tab, event) {
      this.addForm.Name = ''
      this.addForm.Innum = '0'
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetNaoxjStockStocknum()
      this.apiGetNaoxjStockStocklist()
    },
    clickexcel () {
      this.apiExcelNaoxjStockStock()
    },
    funsaveadd () {
      this.apiAddNaoxjStockStock()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickedit (index, row) {
      this.editForm.Id = row.Id
      this.editForm.Name = row.Name
      this.editForm.Innum = row.Innum
      this.editForm.Beizhu = row.Beizhu
      this.editdialog = true
    },
    funsaveedit () {
      this.apiEditNaoxjStockStock()
    },
    apiAddNaoxjStockStock: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: this.addForm.Name,
        innum: this.addForm.Innum,
        beizhu: this.addForm.Beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddNaoxjStockStock, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetNaoxjStockStocknum()
            that.apiGetNaoxjStockStocklist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetNaoxjStockStocklist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockStocklist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetNaoxjStockStocknum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockStocknum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditNaoxjStockStock: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.editForm.Id,
        name: this.editForm.Name,
        innum: this.editForm.Innum,
        beizhu: this.editForm.Beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditNaoxjStockStock, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetNaoxjStockStocklist()
          }
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.editdialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetNaoxjStockCatalogNameList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockCatalogNameList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.nameList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelNaoxjStockStock: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelNaoxjStockStock, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.el-tree{
  height: 350px;
  overflow-y: scroll
}
.el-tree::-webkit-scrollbar {
    display: none;
}
.select2{
    width: 100%;
}
</style>
